import isFilledUp from './fields/isFilledUp'

const validateAvatar = (name, email) => {
  if (!isFilledUp(email)) {
    return { [name]: 'Avatar is required' }
  }
  return {}
}

const validate = values => {
  if (typeof values !== 'object' || values === null) {
    throw new Error(
      'Invalid argument. Validator functions only expect a non-null object.',
    )
  }

  const { displayPhoto } = values

  return {
    ...validateAvatar('displayPhoto', displayPhoto),
  }
}

export default validate
